const billTableColumns = [
  { label: "Status", value: "status" },
  { label: "Cód. Fatura", value: "number" },
  { label: "Filial da empresa", value: "company_branch" },
  { label: "Vlr. Total", value: "total_amount", className: "text-green-400" },
  { label: "N. Transações", value: "events_count" },
  { label: "Abertura", value: "opened_at" },
  { label: "Fechamento", value: "closed_at" },
  { label: "Vencimento", value: "due_at" },
  { label: "Ações", value: "actions", className: "w-9" },
];

export default billTableColumns;

export const governmentAllocationBillsTableColumns = billTableColumns.filter(({ value }) => ![
  'company_branch',
].includes(value));
